import {
  BRAND_EDGE_QUESTIONS,
  BRAND_EDGE_TAGLINE_QUESTION,
  BVA_SECTIONS,
  HUMAN_TENSION_QUESTIONS,
  HUMAN_TENSION_TAGLINE_QUESTION,
  MEANINGFUL_BRAND_ROLE_QUESTION,
  PRODUCT_EDGE_QUESTIONS,
  PRODUCT_EDGE_TAGLINE_QUESTION,
} from 'constants/bvaQuestions'
import { Section } from 'model/section'

const [whoAreYouFor, whatAreTheirBeliefValues, whatNeedAreTheyTryingToFulfill] = HUMAN_TENSION_QUESTIONS
const [sensorialCues, reasonToBelieve, productSuperiorityInsights, functionalBenefit] = PRODUCT_EDGE_QUESTIONS
const [personality, memoryStructure, brandPhilosophy, emotionalBenefit] = BRAND_EDGE_QUESTIONS

/**
 * Static, brand-agnostic demo answers for the BVA wheel preview shown on the
 * Home page (see Figma node 5228:31450). Rendered via HumanTension, which
 * otherwise displays a real brand's answers on the BrandDetails page.
 */
export const FRAMEWORK_WHEEL_SECTIONS: Section[] = [
  {
    section: BVA_SECTIONS.humanTension,
    questions: [
      {
        questionId: 'framework-human-tension-tagline',
        questionText: HUMAN_TENSION_TAGLINE_QUESTION,
        answer: {
          answerId: 'framework-human-tension-tagline-answer',
          answerText: 'Fundamental unresolved tension getting in the way to fulfill audience needs.',
        },
      },
      {
        questionId: 'framework-who-are-you-for',
        questionText: whoAreYouFor,
        answer: { answerId: 'framework-who-are-you-for-answer', answerText: 'Aspirational design audience' },
      },
      {
        questionId: 'framework-belief-values',
        questionText: whatAreTheirBeliefValues,
        answer: {
          answerId: 'framework-belief-values-answer',
          answerText: 'Points to an area where the brand can play a role',
        },
      },
      {
        questionId: 'framework-need-to-fulfill',
        questionText: whatNeedAreTheyTryingToFulfill,
        answer: {
          answerId: 'framework-need-to-fulfill-answer',
          answerText: 'A need in the context of beverages but with a link to their life',
        },
      },
    ],
  },
  {
    section: BVA_SECTIONS.productEdge,
    questions: [
      {
        questionId: 'framework-product-edge-tagline',
        questionText: PRODUCT_EDGE_TAGLINE_QUESTION,
        answer: {
          answerId: 'framework-product-edge-tagline-answer',
          answerText: 'WHAT DIFFERENTIATES THIS PRODUCT FROM OTHER PRODUCTS?',
        },
      },
      {
        questionId: 'framework-sensorial-cues',
        questionText: sensorialCues,
        answer: {
          answerId: 'framework-sensorial-cues-answer',
          answerText: 'What unique physical elements are felt during consumption?',
        },
      },
      {
        questionId: 'framework-reason-to-believe',
        questionText: reasonToBelieve,
        answer: {
          answerId: 'framework-reason-to-believe-answer',
          answerText: 'What distinctive product features support your product benefit?',
        },
      },
      {
        questionId: 'framework-product-superiority-insights',
        questionText: productSuperiorityInsights,
        answer: {
          answerId: 'framework-product-superiority-insights-answer',
          answerText: 'What do consumers say about your product experience vs competition?',
        },
      },
      {
        questionId: 'framework-functional-benefit-product',
        questionText: functionalBenefit,
        answer: {
          answerId: 'framework-functional-benefit-product-answer',
          answerText: 'Based on your RTBs what benefit does your product deliver?',
        },
      },
    ],
  },
  {
    section: BVA_SECTIONS.brandEdge,
    questions: [
      {
        questionId: 'framework-brand-edge-tagline',
        questionText: BRAND_EDGE_TAGLINE_QUESTION,
        answer: {
          answerId: 'framework-brand-edge-tagline-answer',
          answerText: 'WHAT DIFFERENTIATES THIS BRAND FROM OTHER BRANDS?',
        },
      },
      {
        questionId: 'framework-personality',
        questionText: personality,
        answer: { answerId: 'framework-personality-answer', answerText: 'How does your brand sound and look?' },
      },
      {
        questionId: 'framework-memory-structure',
        questionText: memoryStructure,
        answer: {
          answerId: 'framework-memory-structure-answer',
          answerText: "What elicits your brand in people's minds? Ex: packaging, owned assets, etc.",
        },
      },
      {
        questionId: 'framework-brand-philosophy',
        questionText: brandPhilosophy,
        answer: {
          answerId: 'framework-brand-philosophy-answer',
          answerText: 'What does your brand stand for? Is your brand for everyone or exclusive?',
        },
      },
      {
        questionId: 'framework-emotional-benefit',
        questionText: emotionalBenefit,
        answer: { answerId: 'framework-emotional-benefit-answer', answerText: 'How does it make you feel?' },
      },
    ],
  },
  {
    section: BVA_SECTIONS.meaningfulBrandRole,
    questions: [
      {
        questionId: 'framework-meaningful-brand-role',
        questionText: MEANINGFUL_BRAND_ROLE_QUESTION,
        answer: {
          answerId: 'framework-meaningful-brand-role-answer',
          answerText: 'The role the brand plays in the life of an individual resolving the Human Tension',
        },
      },
    ],
  },
]
